//
import CustomerReceivablePaymentRoutes from "./PosCustomerReceivablePayment"

//
export default [
    CustomerReceivablePaymentRoutes,
]